








import Vue from 'vue';
import '@/assets/styles/table.css';
import '@/assets/styles/forms.css';
import '@/assets/styles/search.css';

export default Vue.extend({
  name: 'ConsoleView',
});
